export const WS_HEARTBEAT_INTERVAL_MS = 30_000;
export const WS_PONG_TIMEOUT_MS = 60_000;
export const WS_RECONNECT_BASE_DELAY_MS = 1_000;
export const WS_RECONNECT_MAX_DELAY_MS = 30_000;
export const WS_RECONNECT_MULTIPLIER = 2;
export const WS_RECONNECT_JITTER = 0.2;
// On return-to-foreground (mobile lock / app-switch) the socket may look OPEN
// but be a zombie the OS already tore down. We send one ping and wait this long
// for the pong; no pong ⇒ force-close and reconnect immediately. Deliberately
// far shorter than WS_PONG_TIMEOUT_MS (60s) so the user isn't left staring at a
// dead connection — the user is actively looking at the tab right now.
export const WS_LIVENESS_PROBE_TIMEOUT_MS = 3_000;
export const WS_MESSAGE_QUEUE_MAX_SIZE = 100;

// Mirror of the server's reasoning-tier turn bound (meridian.ReasoningTurnBound,
// 15 min). Pinned to the Go value by internal/chat
// TestReasoningTurnMaxRun_MatchesFrontendMirror — change both or neither.
export const SERVER_REASONING_TURN_MAX_MS = 900_000;
// How much longer the client waits than the server ON A DEEP TURN, so there the
// server's own timeout or error envelope arrives first. A non-Deep send timer
// gets no grace (sendTimeoutMsFor in features/chat/turnWaits.ts). The outbox
// in-flight guard adds this grace to the send timer on every tier.
export const CHAT_TURN_CLIENT_GRACE_MS = 30_000;

// ===== Chat outbox (CHAT-12) =====
// How long a composed-but-unsent chat message keeps draining automatically. Past
// this it stops being automatic and asks the user, rather than arriving minutes
// late as an answer they have stopped waiting for. It is never discarded.
export const CHAT_SEND_STALE_MS = 60_000;
// How long a dispatched entry blocks its session's next drain is per tier and
// lives in features/chat/turnWaits.ts (inflightMaxMsFor): the send timer plus
// CHAT_TURN_CLIENT_GRACE_MS, because a guard that released before the turn's own
// timeout would re-drain a live turn.
// Refuse a new entry past this rather than silently dropping the oldest, which
// is the transport queue's failure mode and one of the defects this replaces.
export const CHAT_OUTBOX_MAX_ENTRIES = 50;
// How long the WS manager waits for the server's authenticationSuccessResponse
// after (re)connecting before it stops holding back other outbound traffic.
// Normal-case latency is sub-second; this is headroom for a slow link. On a
// timeout (or auth error → enrollment/logout handled elsewhere) we proceed
// best-effort rather than hang.
export const WS_AUTH_CONFIRM_TIMEOUT_MS = 8_000;
// Watchdog on the WebSocket CONNECTING state. A socket has three ways to leave
// CONNECTING: onopen, onclose, or *never* — and mobile browsers (Android Chrome
// especially) can leave a socket started at/around tab-resume wedged half-open
// forever, firing neither handler. Without this timeout the whole reconnect
// ladder stalls and the hard-block overlay ("Reconnecting to server…") never
// clears (it resets only in onopen). If a socket hasn't opened or closed within
// this window we force-close it and reconnect. Longer than the liveness probe
// (3s), shorter than the pong timeout (60s) — a genuine connect never needs 10s.
export const WS_CONNECT_TIMEOUT_MS = 10_000;

export const MAX_NODES_TO_RENDER = 1_000;
export const NODE_PROGRESS_MAX_CARDS = 10;
export const NODE_PROGRESS_FADE_MS = 3_000;

export const DEBOUNCE_SEARCH_MS = 300;
export const PAGINATION_DEFAULT_LIMIT = 20;
export const CHAT_INPUT_MAX_HEIGHT_PX = 200;

export const SIDEBAR_EXPANDED_WIDTH = 260;
export const SIDEBAR_COLLAPSED_WIDTH = 64;

// SessionGuard — see docs/plans/2026-04-29-ws-security-ux-design.md
// Use `||` not `??` so that empty-string env vars fall back to the default
// (Number("") returns 0, which would disable timers entirely).
export const WS_SOFT_BLOCK_GRACE_MS = Number(
  process.env.NEXT_PUBLIC_WS_SOFT_BLOCK_GRACE_MS || 10_000,
);
export const WS_HARD_BLOCK_THRESHOLD_MS = Number(
  process.env.NEXT_PUBLIC_WS_HARD_BLOCK_THRESHOLD_MS || 30_000,
);
export const WS_RECONNECT_GIVE_UP_MS = Number(
  process.env.NEXT_PUBLIC_WS_RECONNECT_GIVE_UP_MS || 300_000,
);
export const IDLE_TIMEOUT_MS = Number(
  process.env.NEXT_PUBLIC_IDLE_TIMEOUT_MS || 1_800_000,
);
export const IDLE_WARNING_LEAD_MS = Number(
  process.env.NEXT_PUBLIC_IDLE_WARNING_LEAD_MS || 60_000,
);
